import React, { useEffect, useState, useCallback } from 'react';
import { IconButton } from '@mui/material';
import AccessibleIcon from '@mui/icons-material/Accessible';
import { useTranslation } from 'react-i18next';

// A floating accessibility button (glass style) that opens the AccessibilityToolbar via Ctrl+F2
// - Appears above the Chatbot button on both mobile and desktop
// - Hides automatically when the Chatbot drawer is open
export default function FloatingAccessibilityButton() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const [chatbotOpen, setChatbotOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => setChatbotOpen(!!e?.detail?.open);
    window.addEventListener('chatbot-open-changed', handler);
    return () => window.removeEventListener('chatbot-open-changed', handler);
  }, []);

  const openAccessibility = useCallback(() => {
    const ev = new KeyboardEvent('keydown', { ctrlKey: true, key: 'F2' });
    window.dispatchEvent(ev);
  }, []);

  if (chatbotOpen) return null;

  return (
    <IconButton
      onClick={openAccessibility}
      aria-label="إمكانية الوصول"
      sx={{
        position: 'fixed',
        left: '18px',
        bottom: { xs: 'max(90px, calc(70px + env(safe-area-inset-bottom)))', sm: 90 },
        zIndex: 1000,
        width: { xs: 44, sm: 56 },
        height: { xs: 44, sm: 56 },
        borderRadius: '50%',
        // Glassmorphism background
        backgroundColor: 'rgba(255, 255, 255, 0.35)',
        backdropFilter: 'saturate(180%) blur(14px)',
        WebkitBackdropFilter: 'saturate(180%) blur(14px)',
        border: '1px solid rgba(255, 255, 255, 0.45)',
        boxShadow: '0 8px 18px rgba(0,0,0,0.18)',
        color: 'primary.main',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          transform: 'scale(1.04)'
        },
        transition: 'transform 0.2s ease, background-color 0.2s ease',
      }}
    >
      <AccessibleIcon sx={{ fontSize: { xs: 22, sm: 26 } }} />
    </IconButton>
  );
}
